import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import UserPage from './pages/UserPage';
import ItemPage from './pages/ItemPage';
import UploadPage from './pages/UploadPage';
import ShoppingCart from './components/ShoppingCart';
import SearchResultsPage from './pages/SearchResultsPage'; // <-- Agregada

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          {/* Este div es clave para la solución del sticky footer */}
          <div className="app-container">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/product/upload" element={<UploadPage />} />
                <Route path="/user/:userId" element={<UserPage />} />
                <Route path="/product/:productId" element={<ItemPage />} />
                <Route path="/cart" element={<ShoppingCart />} />
                <Route path="/search" element={<SearchResultsPage />} /> {/* <-- Agregada */}
              </Routes>
            </main>
            <Footer />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;